import { Flex, Text } from "@minervaproject/fds";
import { capitalize } from "lodash";

import { REACTION_INFO_MAP } from "components/shared/signals_and_reactions";
import { useAppDispatch, useAppSelector } from "hooks/redux_hooks";
import { setUserReaction } from "shared/reducers/classroom";
import { ReactionType } from "shared/types/user";
import { localSelectors } from "store";

function Reaction({ reaction, handleClick }: { reaction: string; handleClick: () => void }) {
  const { color, color2, ReactionIcon, shortcut } = REACTION_INFO_MAP[reaction];
  const shortcutBg = color2 ? `bg-${color2}` : `bg-${color}-tint-20`;

  return (
    <li
      className={`bg-${color}`}
      style={{ width: "400px", height: "48px", borderRadius: "48px", margin: "0 auto 12px" }}
    >
      <button
        aria-label={`Emote ${reaction}`}
        type="button"
        className="button-reset text-white cursor-pointer"
        style={{ width: "100%" }}
        onClick={handleClick}
      >
        <Flex alignItems="center" className="justify-between">
          <Flex className="items-center">
            <ReactionIcon width={48} height={48} />
            <Text bold kind="body-l" ml={5}>
              {capitalize(reaction)}
            </Text>
          </Flex>
          <Flex
            alignItems="center"
            mr={2}
            px={2}
            className={`justify-center ${shortcutBg}`}
            style={{
              width: "88px",
              height: "36px",
              borderRadius: "36px",
            }}
          >
            <Text bold kind="body-l">{`shift + ${shortcut}`}</Text>
          </Flex>
        </Flex>
      </button>
    </li>
  );
}

function ReactionGroup({
  reactions,
  last,
  hideModal,
}: {
  reactions: string[];
  last: boolean;
  hideModal: () => void;
}) {
  const dispatch = useAppDispatch();
  const currentUserId = useAppSelector(localSelectors.selectCurrentUserId());

  const handleClick = (reaction: string) => {
    dispatch(setUserReaction({ userId: currentUserId, reaction: reaction as ReactionType }));
    hideModal();
  };

  return (
    <ul className={`${last ? "" : " mb10"}`}>
      {reactions.map((reaction) => (
        <Reaction key={reaction} reaction={reaction} handleClick={() => handleClick(reaction)} />
      ))}
    </ul>
  );
}

function Reactions({ hideModal }: { hideModal: () => void }) {
  const reactionGroups = [
    ["like", "dislike"],
    ["agree", "disagree"],
    ["laugh", "wow"],
    ["love", "clap"],
  ];

  return (
    <>
      {reactionGroups.map((reactions, index) => (
        <ReactionGroup
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          reactions={reactions}
          last={index === reactionGroups.length - 1}
          hideModal={hideModal}
        />
      ))}
    </>
  );
}

export { Reaction, ReactionGroup, Reactions };
